// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/lib/employees.tsx

export interface Employee {
  id: string;
  name: string;
  photo: string;
  email: string;
  descriptionKey: string;
}

export const employeesData = {
  employees: [
    {
      id: "SR",
      name: "Safet Ramadani",
      photo: "/employees/SR_1.jpg",
      email: "Safet.Ramadani@estata.com",
      descriptionKey: "employees.SR.description"
    },
    {
      id: "AS",
      name: "Andreas Sutic",
      photo: "/employees/AS_1.jpg",
      email: "Andreas.Sutic@estata.com",
      descriptionKey: "employees.AS.description"
    },
    {
      id: "IG",
      name: "Ines Gebhardt",
      photo: "/employees/IG_1.jpg",
      email: "Ines.Gebhardt@estata.com",
      descriptionKey: "employees.IG.description"
    },
    {
      id: "YS",
      name: "Yuliia Semenova",
      photo: "/employees/YS_1.jpg",
      email: "Yuliia.Semenova@estata.com",
      descriptionKey: "employees.YS.description"
    },
    {
      id: "TW",
      name: "Tanja Wittkowski",
      photo: "/employees/TW_1.jpg",
      email: "Tanja.Wittkowski@estata.com",
      descriptionKey: "employees.TW.description"
    },
    {
      id: "NZ",
      name: "Nele Zielinske",
      photo: "/employees/NZ_1.jpg",
      email: "Nele.Zielinske@estata.com",
      descriptionKey: "employees.NZ.description"
    },
    {
      id: "AD",
      name: "Aiko Domke",
      photo: "/employees/AD_1.jpg",
      email: "Aiko.Domke@estata.com",
      descriptionKey: "employees.AD.description"
    },
    {
      id: "GK",
      name: "Gamze Küller",
      photo: "/employees/GK_1.jpg",
      email: "Gamze.Kueller@estata.com",
      descriptionKey: "employees.GK.description"
    },
    {
      id: "AC",
      name: "Andrés Cruz",
      photo: "/employees/AC_1.jpg",
      email: "Andres.Cruz@estata.com",
      descriptionKey: "employees.AC.description"
    },
    {
      id: "PR",
      name: "Peter Rickert",
      photo: "/employees/PR_1.jpg",
      email: "Peter.Rickert@estata.com",
      descriptionKey: "employees.PR.description"
    },
    {
      id: "CS",
      name: "Claudio Squella",
      photo: "/employees/CS_1.jpg",
      email: "Claudio.Squella@estata.com",
      descriptionKey: "employees.CS.description"
    },
    {
      id: "VS",
      name: "Valentina Sierralta",
      photo: "/employees/VS_1.jpg",
      email: "Valentina.Sierralta@estata.com",
      descriptionKey: "employees.VS.description"
    },
  ]
};

export const getEmployeesByIds = (ids: string[]): Employee[] => {
  return ids
    .map(id => employeesData.employees.find(emp => emp.id === id))
    .filter((emp): emp is Employee => emp !== undefined);
};